module.exports = __webpack_public_path__ + "img/green-cer-mb.cff14f18.webp";